import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mb-buffering',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./buffering.component.scss'],
})
export class BufferingComponent {}
